import { render, staticRenderFns } from "./addUpdHowz.vue?vue&type=template&id=11208b4a&scoped=true"
import script from "./addUpdHowz.vue?vue&type=script&lang=js"
export * from "./addUpdHowz.vue?vue&type=script&lang=js"
import style0 from "./addUpdHowz.vue?vue&type=style&index=0&id=11208b4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11208b4a",
  null
  
)

export default component.exports